import { requestProjectApi } from 'serviceWorker/api/requestApi';
import { shareableUrlPathOf, ShareableUrlTarget } from 'shared/domain/issue/issueShareableUrl';
import type { IncomingEmailMessageContentInDto } from 'shared/dtos/in/issue';
import type { ChangelogOutDto } from 'shared/types/changelogV2';

/* Issue data the server answers on request; it is not stored in IndexedDB. */

export function getIncomingEmailMessageContent({
  issueId,
  contentId,
}: {
  issueId: string;
  contentId: string;
}): Promise<IncomingEmailMessageContentInDto> {
  return requestProjectApi({ method: 'GET', path: `issue/${issueId}/incomingEmailMessageContent/${contentId}` });
}

export async function getShareableUrl(target: ShareableUrlTarget): Promise<string> {
  const { url } = await requestProjectApi<{ url: string }>({ method: 'GET', path: shareableUrlPathOf(target) });
  return url;
}

export function getIssueChangelog({ issueId }: { issueId: string }): Promise<ChangelogOutDto> {
  return requestProjectApi({ method: 'GET', path: `issue/${issueId}/changeLog` });
}
